import { render, staticRenderFns } from "./ModalDocument.vue?vue&type=template&id=6a0f4dbe"
import script from "./ModalDocument.vue?vue&type=script&lang=js"
export * from "./ModalDocument.vue?vue&type=script&lang=js"
import style0 from "./ModalDocument.vue?vue&type=style&index=0&id=6a0f4dbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports